import React, { PureComponent } from 'react';

const link = `${ARTICLE_CONFIG.baseUrl}${ARTICLE_CONFIG.teaserLink}`;
const title = ARTICLE_CONFIG.teaserTitle || 'Die Wahl kurz analysiert';
const subtitle = ARTICLE_CONFIG.teaserSubtitle || 'Gewinner, Verlierer, mögliche Koalitionen';
const imgSrc = ARTICLE_CONFIG.teaserImgPath || 'images/analyse_teaser.jpg';

class Teaser extends PureComponent {
  render() {
    if (!ARTICLE_CONFIG.showTeaser) {
      return null;
    }

    return (
      <a className="teaser" href={link} target="_blank">
        {/* <div className="teaser__img" style="background-image: url({imgSrc});"></div> */}
          <img src={imgSrc} />
        <div className="teaser__content">
          <div className="teaser__content-title">{title}</div>
          <div className="teaser__content-text">{subtitle}</div>
        </div>
      </a>
    );
  }
}

export default Teaser;
